export function convertTimestamp<T extends object>(value: T): T | Date {
  if (value === null || typeof value === 'undefined') { return value; }

  try {
    return (value as Timestamp).toDate();
  } catch (err) {
    console.log('Timstamp conversion error', err);
    return value;
  }
}

interface Timestamp {
  toDate(): Date;
}